import React from "react";
import { Link } from "react-router-dom";
import { Survey } from "./survey-types";

type SurveyListProps = {
  surveys: Survey[];
};

function formatDate(dateStr: string) {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export const SurveyList: React.FC<SurveyListProps> = ({ surveys }) => {
  return (
    <div className="">
      {surveys.length ? (
        <ul className="flex flex-col gap-4">
          {surveys.map((survey) => (
            <li key={survey.id}>
              <Link
                to={`/surveys/${survey.id}`}
                className="block p-4 border border-gray-300 rounded-sm hover:bg-slate-700 "
              >
                {survey.header?.title || "Untitled"}
                <div className="text-xs text-slate-400">
                  {survey.header?.contextAndObjectives}
                </div>
                <div className="text-xs text-slate-400">
                  - {formatDate(survey.metadata.creationDate)}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <div className="mb-12 mt-12 italic text-slate-300">No surveys yet</div>
      )}
    </div>
  );
};
